import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconCalendar = createIcon({
  viewBox: '0 0 64 64',
  path: (
    <>
      <rect
        x="11.8711"
        y="13.4194"
        width="40.7742"
        height="40.7742"
        fill="#CFDAEC"
      />
      <rect
        x="11.8711"
        y="13.4194"
        width="40.7742"
        height="11.3548"
        fill="#0D47A1"
      />
      <path
        d="M20.2199 22.1708C21.8483 22.1708 23.1683 20.8507 23.1683 19.2224C23.1683 17.594 21.8483 16.2739 20.2199 16.2739C18.5915 16.2739 17.2715 17.594 17.2715 19.2224C17.2715 20.8507 18.5915 22.1708 20.2199 22.1708Z"
        fill="#CFDAEC"
      />
      <path
        d="M44.1848 22.1708C45.8131 22.1708 47.1332 20.8507 47.1332 19.2224C47.1332 17.594 45.8131 16.2739 44.1848 16.2739C42.5564 16.2739 41.2363 17.594 41.2363 19.2224C41.2363 20.8507 42.5564 22.1708 44.1848 22.1708Z"
        fill="#CFDAEC"
      />
      <path
        d="M27.409 33.6646H17.4219V43.6516H27.409V33.6646Z"
        fill="#86A3D0"
      />

      <rect
        x="18.5801"
        y="9.80664"
        width="3.6129"
        height="10.3226"
        rx="1.80645"
        fill="#E6ECF5"
      />
      <rect
        x="42.3223"
        y="9.80664"
        width="3.6129"
        height="10.3226"
        rx="1.80645"
        fill="#E6ECF5"
      />
    </>
  ),
});

export default IconCalendar;
